'use client';

import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import { LuX } from 'react-icons/lu';
export const FormDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  children,
  confirmButtonText = 'Save',
  cancelButtonText = 'Cancel',
  disableConfirm = false,
  confirmLoading = false,
  hideConfirm = false,
  validationError = null,
  maxWidth = 'lg'
}) => {
  const busy = confirmLoading;
  const showConfirm = !hideConfirm && !!onConfirm;
  const confirmButton = showConfirm ? <Button variant="contained" color="primary" disableElevation onClick={onConfirm} disabled={disableConfirm || busy} startIcon={busy ? <CircularProgress color="inherit" size={18} /> : undefined} className="min-w-28!">
            {busy ? 'Saving...' : confirmButtonText}
        </Button> : null;
  return <Dialog open={open} onClose={(_, reason) => {
    if (busy) return;
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      onClose();
    } else {
      onClose();
    }
  }} disableEscapeKeyDown={busy} maxWidth={maxWidth} fullWidth PaperProps={{
    sx: {
      borderRadius: '8px'
    }
  }}>
            <DialogTitle className="justify-between! flex! items-center! gap-2!">
                <span className="flex min-w-0 flex-col gap-0.5">
                    <span className="flex flex-wrap items-center gap-2.5">{title}</span>
                    {description ? <span className="text-xs font-normal text-foreground-muted">{description}</span> : null}
                </span>
                <IconButton size="small" onClick={onClose} className="-mr-1.5! shrink-0!" disabled={busy}>
                    <LuX className="text-base" />
                </IconButton>
            </DialogTitle>
            <DialogContent className="-mt-2! -mb-1!">{children}</DialogContent>
            <DialogActions className="px-5! pb-5! gap-2!">
                <Button variant="contained" color="neutral" disableElevation onClick={onClose} disabled={busy} className="min-w-28!">
                    {cancelButtonText}
                </Button>
                {confirmButton && (validationError ? <Tooltip title={validationError} arrow placement="top">
                            <span>{confirmButton}</span>
                        </Tooltip> : confirmButton)}
            </DialogActions>
        </Dialog>;
};
export default FormDialog;